import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import {
  Typography,
  Row,
  Col,
  Table,
  Form,
  Modal,
  Icon,
  Input,
  DatePicker,
  Select,
  Avatar,
  Button,
  message,
} from "antd";
import moment from "moment";
import { checkLinkURL } from "../../../../../utils/auth";
import {
  LoadingOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  SaveOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { alertMessage } from "../../../../../utils/message";
import ModalshowAllImageBase64 from "../../../../../components/user/ModalshowAllImage/newsBase64";
import { Span } from "../../../../../components/element";

const { Text, Title } = Typography;
const { Option } = Select;

class WelfareListStudyPaymentSecAttachment extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
    ModalshowAllImageVisible: false,
    ModalshowAllImageTitle: null,
    ModalshowAllImageData: [],
    ModalshowAllImageArrayId: null,
    ModalshowAllImageDatabase: true,
    summaryStudyFeeDetailPrice: null,
    columns: [
      {
        title: "ลำดับ",
        dataIndex: "noTable",
        align: "center",
        width: "80px",
        render: (item, record, index) => <span>{index + 1}</span>,
      },
      // {
      //   title: "เอกสาร",
      //   dataIndex: "studyFeeDetailType",
      //   align: "center",
      //   width: "200px",
      //   render: (item, record, index) => (
      //     <Form.Item className="mb-0">
      //       {this.props.form.getFieldDecorator(
      //         `studyEducationFeeDetailAttach[${index}].studyFeeDetailType`,
      //         {
      //           initialValue: record.studyFeeDetailType
      //             ? record.studyFeeDetailType
      //             : null,
      //           rules: [
      //             {
      //               required: true,
      //               message: "กรุณาระบุ รายละเอียด",
      //             },
      //           ],
      //         }
      //       )(
      //         <Select
      //           style={{ width: "100%" }}
      //           // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
      //           disabled={this.props.isViewOnly}
      //           showSearch
      //           placeholder="กรุณาเลือก จังหวัด"
      //           onChange={(e) =>
      //             this.onChangeValueForm(index, e, "studyFeeDetailType")
      //           }
      //           //optionFilterProp="children"
      //         >
      //           {this.props.dropdownAttachment.map((valuesLabel, keys) => {
      //             return (
      //               <Option value={valuesLabel.dropDownValueTh} key={keys}>
      //                 {valuesLabel.dropDownNameTh}
      //               </Option>
      //             );
      //           })}
      //         </Select>
      //       )}
      //     </Form.Item>
      //   ),
      // },
      {
        title: <Span req>รายการเอกสารอื่นๆ</Span>,
        dataIndex: "studyFeeDetailDescription",
        width: "220px",
        align: "center",
        render: (item, record, index) => (
          <>
            <Form.Item className="mb-0">
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetailAttach[${index}].studyFeeDetailDescription`,
                {
                  initialValue: item ? item : "",
                  rules: [
                    {
                      required: true,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                  onBlur={(e) =>
                    this.onChangeValueForm(
                      index,
                      e,
                      "studyFeeDetailDescription"
                    )
                  }
                />
              )}
            </Form.Item>
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetailAttach[${index}].isDeleted`,
                {
                  initialValue: record.isDeleted ? record.isDeleted : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetailAttach[${index}].studyFeeDetailSlipDate`,
                {
                  initialValue: record.studyFeeDetailSlipDate
                    ? moment(record.studyFeeDetailSlipDate)
                    : moment(),
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ วันที่ในใบเสร็จ",
                    },
                  ],
                }
              )(
                <DatePicker
                  //disabledDate={this.disabledApprovePaymentDate}
                  disabled={this.props.isViewOnly}
                  //format={this.dateFormatNumber(`studyFeeDetailSlipDate`)}
                  className="w-100"
                  placeholder="เลือกวันที่"
                  allowClear={false}
                />
              )}
            </Form.Item>

            {record.studyEducationFeeDetailId && (
              <Form.Item className="mb-0" hidden>
                {this.props.form.getFieldDecorator(
                  `studyEducationFeeDetailAttach[${index}].studyEducationFeeDetailId`,
                  {
                    initialValue: record.studyEducationFeeDetailId
                      ? record.studyEducationFeeDetailId
                      : "-",
                    rules: [
                      {
                        required: false,
                        message: "กรุณาระบุ รายละเอียด",
                      },
                    ],
                  }
                )(
                  <Input
                    className="w-100"
                    placeholder="ระบุ รายละเอียด"
                    disabled={this.props.isViewOnly}
                    allowClear={false}
                  />
                )}
              </Form.Item>
            )}
            {record.studyEducationFeeAttachfile.studyFeeAttachmentId && (
              <>
                <Form.Item className="mb-0" hidden>
                  {this.props.form.getFieldDecorator(
                    `studyEducationFeeDetailAttach[${index}].studyFeeAttachmentId`,
                    {
                      initialValue: record.studyFeeAttachmentId
                        ? record.studyFeeAttachmentId
                        : "-",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุ รายละเอียด",
                        },
                      ],
                    }
                  )(
                    <Input
                      className="w-100"
                      placeholder="ระบุ รายละเอียด"
                      disabled={this.props.isViewOnly}
                      allowClear={false}
                    />
                  )}
                </Form.Item>
                <Form.Item className="mb-0" hidden>
                  {this.props.form.getFieldDecorator(
                    `studyEducationFeeDetailAttach[${index}].studyFeeAttachment[0].studyFeefileType`,
                    {
                      initialValue: record.studyEducationFeeAttachfile[0]
                        .studyFeefileType
                        ? record.studyEducationFeeAttachfile[0].studyFeefileType
                        : "-",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุ รายละเอียด",
                        },
                      ],
                    }
                  )(
                    <Input
                      className="w-100"
                      placeholder="ระบุ รายละเอียด"
                      disabled={this.props.isViewOnly}
                      allowClear={false}
                    />
                  )}
                </Form.Item>
                <Form.Item className="mb-0" hidden>
                  {this.props.form.getFieldDecorator(
                    `studyEducationFeeDetailAttach[${index}].studyFeeAttachment[0].studyFeefileName`,
                    {
                      initialValue: record.studyEducationFeeAttachfile[0]
                        .studyFeefileName
                        ? record.studyEducationFeeAttachfile[0].studyFeefileName
                        : "-",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุ รายละเอียด",
                        },
                      ],
                    }
                  )(
                    <Input
                      className="w-100"
                      placeholder="ระบุ รายละเอียด"
                      disabled={this.props.isViewOnly}
                      allowClear={false}
                    />
                  )}
                </Form.Item>
                <Form.Item className="mb-0" hidden>
                  {this.props.form.getFieldDecorator(
                    `studyEducationFeeDetailAttach[${index}].studyFeeAttachment[0].studyFeefilePath`,
                    {
                      initialValue: record.studyEducationFeeAttachfile[0]
                        .studyFeefilePath
                        ? record.studyEducationFeeAttachfile[0].studyFeefilePath
                        : "-",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุ รายละเอียด",
                        },
                      ],
                    }
                  )(
                    <Input
                      className="w-100"
                      placeholder="ระบุ รายละเอียด"
                      disabled={this.props.isViewOnly}
                      allowClear={false}
                    />
                  )}
                </Form.Item>

                <Form.Item className="mb-0" hidden>
                  {this.props.form.getFieldDecorator(
                    `studyEducationFeeDetailAttach[${index}].studyFeeAttachment[0].studyFeefileType`,
                    {
                      initialValue: record.studyEducationFeeAttachfile[0]
                        .studyFeefileType
                        ? record.studyEducationFeeAttachfile[0].studyFeefileType
                        : "-",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุ รายละเอียด",
                        },
                      ],
                    }
                  )(
                    <Input
                      className="w-100"
                      placeholder="ระบุ รายละเอียด"
                      disabled={this.props.isViewOnly}
                      allowClear={false}
                    />
                  )}
                </Form.Item>
              </>
            )}
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetailAttach[${index}].studyFeeDetailInvoiceNo`,
                {
                  initialValue: record.studyFeeDetailInvoiceNo
                    ? record.studyFeeDetailInvoiceNo
                    : "",
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ วันที่ในใบเสร็จ",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ วันที่ในใบเสร็จ"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetailAttach[${index}].studyFeeDetailActualPrice`,
                {
                  initialValue: record.studyFeeDetailActualPrice
                    ? record.studyFeeDetailActualPrice
                    : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ วันที่ในใบเสร็จ",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ วันที่ในใบเสร็จ"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetailAttach[${index}].studyFeeDetailRemark`,
                {
                  initialValue: record.studyFeeDetailRemark
                    ? record.studyFeeDetailRemark
                    : "-",
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetailAttach[${index}].studyFeeDetailPrice`,
                {
                  initialValue: record.studyFeeDetailActualPrice
                    ? record.studyFeeDetailActualPrice
                    : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ วันที่ในใบเสร็จ",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ วันที่ในใบเสร็จ"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
            {/* <Form.Item className="mb-0" hidden>
           {this.props.form.getFieldDecorator( `studyEducationFeeDetailAttach[${index}].studyFeeAttachment[0].isDeleted`, {
             initialValue: record.studyEducationFeeAttachfile[0].isDeleted ? record.studyEducationFeeAttachfile[0].isDeleted : 0,
             rules: [
               {
                 required: false,
                 message: "กรุณาระบุ รายละเอียด",
               },
             ],
           })(
             <Input
               className="w-100"
               placeholder="ระบุ รายละเอียด"
               disabled={this.props.isViewOnly}
               allowClear={false}
             />
             
           )}
         </Form.Item>
         <Form.Item className="mb-0" hidden>
           {this.props.form.getFieldDecorator( `studyEducationFeeDetailAttach[${index}].studyFeeAttachment[0].studyFeeAttachmentSort`, {
             initialValue: record.studyEducationFeeAttachfile[0].studyFeeAttachmentSort ? record.studyEducationFeeAttachfile[0].studyFeeAttachmentSort : 0,
             rules: [
               {
                 required: false,
                 message: "กรุณาระบุ รายละเอียด",
               },
             ],
           })(
             <Input
               className="w-100"
               placeholder="ระบุ รายละเอียด"
               disabled={this.props.isViewOnly}
               allowClear={false}
             />
             
           )}
         </Form.Item> */}
          </>
          // </>
        ),
      },
      {
        title: <Span req>เอกสารแนบ</Span>,
        width: "200px",
        dataIndex: "studyEducationFeeAttachfile",
        align: "center",
        render: (item, record, index) => {
          // record.studyEducationFeeAttachfile[0]?.studyFeeAttachmentId &&
          // record.studyEducationFeeAttachfile[0]?.studyFeefileName
          //   ? this.showMoreFileUploadsAttach(
          //       index,
          //       record.studyEducationFeeAttachfile[0]
          //     )
          //   : this.inputFormUploads(index, record),
          return (
            <>
              {!this.props.isViewOnly &&
                this.inputFormUploads(index, item, record)}
              {this.showMoreFileUploadsAttach(
                index,
                record.studyEducationFeeAttachfile
              )}
            </>
          );
        },
      },
      {
        title: "จัดการ",
        align: "center",
        width: "80px",
        dataIndex: "orgTable",
        render: (item, record, index) => {
          return this.showDetailBtnInput(
            record,
            index,
            record.studyEducationFeeDetailId
          );
        },
      },
    ],
  };

  onChangeValueForm = async (arrayId, values, name) => {
    const { dataTalbeUploads } = this.state;
    let dataSourceitems = [...this.state.dataAttachOtherData];
    let item = { ...dataSourceitems[arrayId] };

    console.log("item onchange values", values);
    console.log("item onchange name", name);
    console.log("item onchange", item);
    if (name == "studyFeeDetailDescription") {
      item.studyFeeDetailDescription = values.target.value;
    } else if (name == "studyFeeDetailType") {
      item.studyFeeDetailType = values;
    } else if (name == "file") {
      item.file = values;
    }
    dataSourceitems[arrayId] = item;

    console.log("dataSourceitems", dataSourceitems);
    await this.setState(
      {
        dataAttachOtherData: dataSourceitems,
      },
      async () => {
        // await this.setSummary()
        // this.cllBackSetValueContactNumber()
      }
    );

    // this.props.onTableChange(dataSourceitems);
  };

  inputFormUploads = (arrayId, item, record) => {
    const { isViewOnly } = this.props;
    const { dataAttachOtherData } = this.state;
    let fileName =
      item.length == 1 && item[0].studyFeefileName
        ? item[0].studyFeefileName
        : item.length > 1 && item[1].studyFeefileName
        ? item[1].studyFeefileName
        : "";
    return (
      <>
        <Form.Item label={""} style={{ marginBottom: "0px" }}>
          {this.props.form.getFieldDecorator(
            `studyEducationFeeDetailAttach[${arrayId}].studyEducationFeeAttachfile`,
            {
              initialValue: item ? item : null,
              // valuePropName: "fileList",
              // rules: [
              //   {
              //     required: true,
              //     message: "กรุณาอัพโหลดไฟล์",
              //     className: "height-input-menu",
              //     valuePropName: "fileList",

              //   },
              // ],
            }
          )(
            <label style={{ lineHeight: 1.5 }}>
              <p
                className="py-2 px-4 mb-0"
                align={"center"}
                style={{ backgroundColor: "#8d0e14", color: "#fff" }}
              >
                อัปโหลด
                <input
                  id={"input-filePayments-" + arrayId}
                  className="input-file"
                  // name={uploadName}
                  type="file"
                  accept="image/png, image/jpeg, application/pdf"
                  onChange={(e) =>
                    this.handleAddUploadsFile2(e.target.files, arrayId)
                  }
                />
              </p>
              <p style={{ fontSize: "12px" }} className="my-2">
                แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf
              </p>
              <p
                className={fileName == "" && "color-red"}
                style={{ lineHeight: 1.2 }}
              >
                {fileName == "" && (
                  <p id={"showTextUplodas" + arrayId}>
                    กรุณาเลือก อัปโหลดรูปภาพหรือไฟล์
                  </p>
                )}
              </p>
            </label>
          )}
        </Form.Item>
      </>
    );
  };

  ModalshowAllImageShow = async (data, title, arrayId, modalTypeUpload) => {
    console.log("data ModalshowAllImageShow", data);
    let dataArrayImage = data;
    let dataShowImage = [];
    // if(data[0].ModalShowImage){
    //    dataArrayImage = data.ModalShowImage
    // }

    dataArrayImage.map((resultObj, _index) => {
      if (resultObj.isDeleted != 1) {
        dataShowImage.push(resultObj);
      }
    });

    console.log("dataArrayImage", data);

    await this.setState({
      ModalshowAllImageVisible: true,
      ModalshowAllImageTitle: title,
      ModalshowAllImageData: dataShowImage,
      ModalshowAllImageArrayId: arrayId,
      ModalTypeUpload: modalTypeUpload,
    });
  };

  ModalshowAllImageHide = async () => {
    await this.setState({
      ModalshowAllImageVisible: false,
      ModalshowAllImageTitle: null,
      ModalshowAllImageData: [],
      ModalshowAllImageArrayId: null,
    });
  };

  showDetailBtnInput = (record, arrayId, id) => {
    const { isViewOnly } = this.props;
    const { dataAttachOtherData } = this.state;
    // disabled={ this.props.isViewOnly }
    return (
      <>
        {console.log("arrayId show data", arrayId)}
        <Avatar
          shape="square"
          icon={<DeleteOutlined />}
          className={`mr-1 mb-1 ${!isViewOnly && "bg-red"}`}
          onClick={() => {
            !isViewOnly && this.destroyArrayDataUploads(arrayId, id, record);
          }}
          style={{
            cursor: (!isViewOnly && "pointer") || "no-drop",
            backgroundColor: !isViewOnly ? "#D7222A" : "#CCC",
          }}
        />
      </>
    );
  };

  destroyArrayDataUploads = async (arrayId, diasterAttachId = null, record) => {
    const { form, onChangeDeletedAttachment } = this.props;
    const { dataAttachOtherData } = this.state;
    var arrayDataSource = [...this.state.dataAttachOtherData];
    arrayDataSource.splice(arrayId, 1);

    //await this.hideModalConfirm();
    console.log("arrayDataSource before", arrayDataSource);
    console.log("destroyArray", arrayId);
    console.log("diasterAttachId", diasterAttachId);

    if (diasterAttachId) {
      console.log("record destroyArrayDataUploads", record);
      onChangeDeletedAttachment(record);
    }
    await this.setState(
      {
        dataAttachOtherData: arrayDataSource,
        // dataTalbeLength: lengthData
      },
      async () => {
        //await this.props.onTableChange(arrayDataSource);
        let lengthData = arrayDataSource.length;
        await this.setState({
          dataTalbeLength: lengthData,
        });

        const fieldsBeforeMap = this.props.form.getFieldsValue();
        //const { studyRecord } = fields
        console.log("studyRecord fieldsBefore map", fieldsBeforeMap);

        console.log("arrayDataSource.file", arrayDataSource);

        await this.props.form.setFieldsValue({
          studyEducationFeeDetailAttach: arrayDataSource,
        });

        const fields = this.props.form.getFieldsValue();
        //const { studyRecord } = fields
        console.log("studyRecord", fields);
        console.log("arrayDataSource after", arrayDataSource);
      }
    );
  };

  onClickToNewTab2 = (dataFile, typeFile, arrayId) => {
    const { rawData } = this.props;
    //const { linkNewTab} = this.state
    console.log("onClickToNewTab2");
    console.log("onClickToNewTab2 typeFile", typeFile);

    if (typeFile !== "application/pdf") {
      console.log("onClickToNewTab2 non pdf");
      var win = window.open();
      win.document.write(
        '<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' +
          "https://vtrcapi.redcross.or.th" +
          dataFile?.studyFeefilePath +
          '" style="height:100%"/></div>'
      );
    } else {
      var win = window.open();
      win.document.write(
        '<iframe src="' +
          "https://vtrcapi.redcross.or.th" +
          dataFile?.studyFeefilePath +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      );
    }
  };

  modalShowFileCreate2 = async (dataFile, title, arrayId) => {
    // var url = URL.createObjectURL(dataFile)

    console.log("DATAFILE VIEW", dataFile);

    console.log(
      "DATAFILE VIEW full",
      checkLinkURL() + dataFile.studyFeefilePath
    );
    console.log(
      "DATAFILE VIEW full /",
      "https://vtrcapi.redcross.or.th" + dataFile.studyFeefilePath
    );

    const reader = new FileReader();
    if (dataFile.studyFeefileType !== "application/pdf") {
      //  reader.readAsDataURL(dataFile)
      //  reader.onloadend = async (e) => {
      //      var dataURL = reader.result;
      //      await this.setState({
      //          linkNewTab: dataURL
      //      })

      Modal.info({
        className: "modalFickIcons",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "1000px",
        content: (
          <div>
            <hr></hr>
            <div className="mt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col
                  span={10}
                  className="mb-3 block_show_file"
                  style={{ display: "block" }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      padding: "10px 55px",
                    }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <img
                      src={
                        "https://vtrcapi.redcross.or.th" +
                        dataFile.studyFeefilePath
                      }
                      style={{ height: "100%" }}
                    />
                    <a
                      onClick={() =>
                        this.onClickToNewTab2(
                          dataFile,
                          dataFile.studyFeefileType,
                          arrayId
                        )
                      }
                      className="icons-show-images"
                    >
                      <Icon type="eye" style={{ color: "#fff" }} />
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    } else {
      //  reader.readAsDataURL(dataFile)
      //  reader.onloadend = async (e) => {
      //      var dataURL = reader.result;
      //      await this.setState({
      //          linkNewTab: dataURL
      //      })

      Modal.info({
        className: "modalFickIcons",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "1000px",
        content: (
          <div>
            <hr></hr>
            <div className="mt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col
                  span={10}
                  className="mb-3 block_show_file"
                  style={{ display: "block" }}
                >
                  <div
                    style={{ width: "100%", height: "200px" }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <iframe
                      title="show-image"
                      style={{ display: "none", opacity: "0", height: "0" }}
                    />
                    <a
                      onClick={() =>
                        this.onClickToNewTab2(
                          dataFile,
                          dataFile.studyFeefileType,
                          arrayId
                        )
                      }
                      className="color-white"
                    >
                      <Icon type="file-pdf" />
                      <br></br>
                      ดูไฟล์ PDF
                    </a>
                    <br></br>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    }
  };

  handleAddUploadsFile2 = async (images, arrayId) => {
    const { form } = this.props;
    const { dataAttachOtherData, reqAttachDayStatus } = this.state;
    const fields = form.getFieldsValue();
    const { studyEducationFeeDetailAttach } = fields;
    let dataSourceitems = [...this.state.dataAttachOtherData];
    let item = { ...dataAttachOtherData[arrayId] };
    let arrayMap = [...images];

    console.log("item", item);
    await arrayMap.map(async (values, keys) => {
      const isLt2M = values.size / 1024 / 1024 < 20;
      if (
        values.type == "image/jpeg" ||
        values.type == "application/pdf" ||
        values.type == "image/png"
      ) {
        if (!isLt2M) {
          message.error("ไฟล์ขนาดใหญ่เกิน 1MB กรุณาเลือกไฟล์ใหม่อีกครั้ง");
        } else {
          if (item.studyEducationFeeAttachfile.length > 0) {
            item.studyEducationFeeAttachfile.map((valuesData, keys) => {
              if (valuesData.fileIdBase64) {
                item.studyEducationFeeAttachfile[0].isDeleted = 1;
                item.studyEducationFeeAttachfile[0].studyFeeAttachmentSort = 0;
                item.studyEducationFeeAttachfile[1] = values;
                item.studyEducationFeeAttachfile[1].isDeleted = 0;
                item.studyEducationFeeAttachfile[1].studyFeeAttachmentSort = 1;
                item.studyEducationFeeAttachfile[1].studyFeefileName =
                  values.name;
                item.studyEducationFeeAttachfile[1].studyFeefileType =
                  values.type;
                item.studyEducationFeeAttachfile[1].studyFeefilePath = "";
              } else {
                item.studyEducationFeeAttachfile[0] = values;
                item.studyEducationFeeAttachfile[0].studyFeeAttachmentSort = 1;
                item.studyEducationFeeAttachfile[0].isDeleted = 0;
                item.studyEducationFeeAttachfile[0].studyFeefileName =
                  values.name;
                item.studyEducationFeeAttachfile[0].studyFeefileType =
                  values.type;
                item.studyEducationFeeAttachfile[0].studyFeefilePath = "";
              }
            });
          } else {
            item.studyEducationFeeAttachfile[0] = values;
            item.studyEducationFeeAttachfile[0].studyFeeAttachmentSort = 0;
            item.studyEducationFeeAttachfile[0].isDeleted = 0;
            item.studyEducationFeeAttachfile[0].studyFeefileName = values.name;
            item.studyEducationFeeAttachfile[0].studyFeefileType = values.type;
            item.studyEducationFeeAttachfile[0].studyFeefilePath = "";
          }

          //  await form.setFieldsValue({ studyEducationFeeDetailAttach });
          values.base64 = "";

          item = {
            //studyFeeDetailBookNo: item.studyFeeDetailBookNo,
            studyFeeDetailType: "INVOICE",
            studyFeeDetailInvoiceNo: item.studyFeeDetailInvoiceNo,
            studyFeeDetailSlipDate: item.studyFeeDetailSlipDate,
            studyFeeDetailPrice: item.studyFeeDetailPrice,
            studyEducationFeeAttachfile: item.studyEducationFeeAttachfile,
            studyFeeDetailActualPrice: item.studyFeeDetailActualPrice,
          };

          await Object.assign(studyEducationFeeDetailAttach[arrayId], {
            studyEducationFeeAttachfile: item.studyEducationFeeAttachfile,
          });

          studyEducationFeeDetailAttach.map((valuesData, keys) => {
            if (keys == arrayId) {
              valuesData.studyEducationFeeAttachfile =
                item.studyEducationFeeAttachfile;
            }
          });

          console.log(
            "item.studyEducationFeeAttachfile Detail",
            studyEducationFeeDetailAttach
          );
          console.log("itemmmmmm", item);
          console.log("itemmmmmm", dataSourceitems);

          this.setState({
            dataAttachOtherData: dataSourceitems,
          });

          await form.setFieldsValue({ studyEducationFeeDetailAttach });
          await this.getBase64(item.studyEducationFeeAttachfile, arrayId, keys);
        }
      } else {
        alertMessage("กรุณาแนบไฟล์ที่เป็นนามสกุล .jpg, .png หรือ .pdf");
        // message.error('กรุณาแนบไฟล์ที่เป็นนามสกุล .jpg, .png หรือ .pdf');
      }
    });
  };

  getBase64 = async (file, arrayId) => {
    const { form } = this.props;
    const fields = form.getFieldsValue();
    const { studyEducationFeeDetailAttach } = fields;

    file.map((values, keysItem) => {
      console.log("xxvaluesx", values);
      new Promise((resolve) => {
        const reader = new FileReader();
        if (values.studyFeeAttachmentId) {
          // resolve(baseURL);
        } else {
          reader.readAsDataURL(values);
          reader.onload = async () => {
            var baseURL = reader.result.split("base64,");
            console.log("baseURL", baseURL);
            await Object.assign(studyEducationFeeDetailAttach[arrayId], {
              studyEducationFeeAttachfile: (values.base64 = baseURL[1]),
              //  studyEducationFeeAttachfile: values.studyFeefileName = baseURL[1]
              //  studyEducationFeeAttachfile: values.studyFeefileType = baseURL[1]
            });
          };
        }
      });
    });
  };

  showMoreFileUploadsAttach = (arrayId, uploadFile) => {
    const { formRef } = this.props;
    const { dataAttachOtherData, dataAttachOtherDataDocument, checkModal } =
      this.state;

    console.log("showMoreFileUploadsAttach" + arrayId);
    console.log("showMoreFileUploadsAttach uploadFile eiei", uploadFile);
    if (dataAttachOtherData[arrayId]?.studyEducationFeeAttachfile) {
      if (
        dataAttachOtherData[arrayId]?.studyEducationFeeAttachfile?.length != 0
      ) {
        if (uploadFile?.studyFeefilePath) {
          console.log("showMoreFileUploadsAttach filepath");
          return (
            <p
              onClick={() => {
                this.ModalshowAllImageShow(uploadFile, "เอกสาร", arrayId);
              }}
              style={{ cursor: "pointer" }}
              className="btn-show-fileuploads"
            >
              ดูไฟล์เอกสารแนบ
            </p>
          );
        } else {
          console.log("showMoreFileUploadsAttach no studyfilepath", uploadFile);
          return (
            <p
              onClick={() => {
                this.ModalshowAllImageShow(uploadFile, "เอกสาร", arrayId);
              }}
              style={{ cursor: "pointer" }}
              className="btn-show-fileuploads"
            >
              ดูไฟล์เอกสารแนบ
            </p>
          );
        }
      }
    }
  };
  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        var baseURL = reader.result.split("base64,");
        callback(baseURL[1]);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  showDataInputUploads = async () => {
    const { formRef, detailForm, form } = this.props;
    const { dataAttachOtherData, studyLearnRecord } = this.state;

    //console.log("form upload", form.getFieldsValue());

    const rows = {
      studyFeeDetailInvoiceNo: "",
      studyFeeDetailSlipDate: moment(),
      studyFeeDetailPrice: 0.0,
      studyFeeDetailActualPrice: 0.0,
      studyEducationFeeAttachfile: [],
      studyFeeDetailType: null,
      isDeleted: 0,
    };

    console.log("dataAttachOtherData add", dataAttachOtherData);

    await this.setState(
      (prevState) => ({
        dataAttachOtherData: [...prevState.dataAttachOtherData, rows],
      }),
      async () => {
        let lengthData = dataAttachOtherData.length + 1;
        await this.setState({
          dataTalbeLength: lengthData,
        });
        // const fields = formRef.current.getFieldsValue()
        // const { studyLearnRecord } = fields

        console.log("dataAttachOtherData", dataAttachOtherData);
      }
    );
  };

  async componentDidMount() {
    const { match, dataAttachOther } = this.props;
    if (dataAttachOther) {
      console.log("dataAttachOtherDataData", dataAttachOther);

      await dataAttachOther.map((values, keys) => {
        values.studyFeeDetailSlipDate = moment(values.studyFeeDetailSlipDate);

        if (!values.studyFeeDetailInvoiceNo) {
          values.studyFeeDetailInvoiceNo = "";
        }

        if (values.studyEducationFeeAttachfile?.length > 0) {
          values.studyEducationFeeAttachfile.map(
            async (valuesFile, keysFile) => {
              // console.log('checkLinkURL()+values.fileBase64', this.convertImgToBase64(checkLinkURL()+valuesFile.studyFeefilePath))
              await this.toDataURL(
                checkLinkURL() + valuesFile.studyFeefilePath,
                function (dataUrl) {
                  values.studyEducationFeeAttachfile[keysFile].base64 = dataUrl;
                }
              );
              values.studyEducationFeeAttachfile[keysFile].fileIdBase64 =
                valuesFile.studyFeeAttachmentId;
              values.studyEducationFeeAttachfile[keysFile].fileBase64 =
                valuesFile.studyFeefilePath;
              values.studyEducationFeeAttachfile[keysFile].fileMimeType =
                valuesFile.studyFeefileType;
            }
          );
        }
      });

      if (dataAttachOther?.length > 0) {
        this.setState({
          dataAttachOtherData: dataAttachOther,
        });
      } else {
        this.setState({
          dataAttachOtherData: [],
        });
      }
    } else {
      this.setState({
        dataAttachOtherData: [],
      });
    }
  }

  render() {
    const { match, dataAttachOther, isViewOnly } = this.props;
    const {
      loadingFullpage,
      columns,
      dataAttachOtherData,
      ModalshowAllImageVisible,
      ModalshowAllImageTitle,
      ModalshowAllImageData,
      ModalshowAllImageArrayId,
    } = this.state;
    const { getFieldDecorator } = this.props.form;

    {
      console.log("ModalshowAllImageData", ModalshowAllImageData);
    }
    return (
      <>
        <ModalshowAllImageBase64
          title={ModalshowAllImageTitle}
          showModal={ModalshowAllImageVisible}
          data={ModalshowAllImageData}
          hideModal={this.ModalshowAllImageHide}
          dataArrayId={ModalshowAllImageArrayId}
          destroyArrayDataImages={this.destroyArrayDataImages}
          imageDatabase={false}
          //statusForm={statusForm}
        />
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
          className="py-2"
        >
          <Col md={24} className="mb-3">
            <Text className="color-red">
              <span style={{ fontSize: "18px" }}>ข้อมูลเอกสารแนบ</span>
            </Text>
          </Col>

          <Col md={24} className="mb-2">
            <Form.Item className="mb-0" />
            <Table
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              columns={columns}
              dataSource={dataAttachOtherData}
              pagination={false}
            />
          </Col>
          <Col xs={24} md={24} align="right" style={{ textAlign: "right" }}>
            {!isViewOnly && (
              <Button
                style={{ display: "inline-block" }}
                type="primary btn-color-default btn-clear"
                className="mt-1 mr-2"
                //onClick={() => this.showDataInputUploads()}
                onClick={() => this.showDataInputUploads()}
                disabled={isViewOnly}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
        </Row>
      </>
    );
  }
}

WelfareListStudyPaymentSecAttachment.defaultProps = {
  autoFocus: false,
};

WelfareListStudyPaymentSecAttachment.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListStudyPaymentSecAttachment = Form.create()(
  WelfareListStudyPaymentSecAttachment
);

export default withApollo(WrappedWelfareListStudyPaymentSecAttachment);
